/**
 * The version of the shipped SPA bundle.
 *
 * Injected at build time as `VITE_APP_VERSION` from the same `LS_VERSION`
 * build arg that versions the server binary (see rust/Dockerfile), so the
 * footer reports the release that actually shipped instead of a stale
 * literal. Falls back to `dev` when unset — local `vite dev`, or a build
 * (MR/feature) where no release version was predicted.
 */
export const APP_VERSION = import.meta.env.VITE_APP_VERSION ?? 'dev';
